import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Common/Layout';
import Home from './components/Home';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import DebtorsList from './components/Debtors/DebtorsList';
import OrganizersList from './components/Organizers/OrganizersList';
import ManagersList from './components/Managers/ManagersList';
import SrosList from './components/Sros/SrosList';
import DocumentsList from './components/Documents/DocumentsList';
import AuctionsList from './components/Auctions/AuctionsList';
import AccountsList from './components/Accounts/AccountsList';
import LotsList from './components/Lots/LotsList';
import CreditorsList from './components/Creditors/CreditorsList';
import EtpsList from './components/Etps/EtpsList';
import CourtsList from './components/Courts/CourtsList';
import ClassifiersList from './components/Classifiers/ClassifiersList';
import RemindersList from './components/Reminders/RemindersList';
import KnowledgeBase from './components/KnowledgeBase/KnowledgeBase';
import UserProfile from './components/Profile/UserProfile';
import UsersList from './components/Users/UsersList';
import SupportPage from './components/Support/SupportPage';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Layout>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            } />
            <Route path="/debtors" element={
              <ProtectedRoute>
                <DebtorsList />
              </ProtectedRoute>
            } />
            <Route path="/organizers" element={
              <ProtectedRoute>
                <OrganizersList />
              </ProtectedRoute>
            } />
            <Route path="/managers" element={
              <ProtectedRoute>
                <ManagersList />
              </ProtectedRoute>
            } />
            <Route path="/sros" element={
              <ProtectedRoute requireAdmin>
                <SrosList />
              </ProtectedRoute>
            } />
            <Route path="/auctions" element={
              <ProtectedRoute>
                <AuctionsList />
              </ProtectedRoute>
            } />
            <Route path="/lots" element={
              <ProtectedRoute requireAdmin>
                <LotsList />
              </ProtectedRoute>
            } />
            <Route path="/etps" element={
              <ProtectedRoute requireAdmin>
                <EtpsList />
              </ProtectedRoute>
            } />
            <Route path="/courts" element={
              <ProtectedRoute>
                <CourtsList />
              </ProtectedRoute>
            } />
            <Route path="/classifiers" element={
              <ProtectedRoute requireAdmin>
                <ClassifiersList />
              </ProtectedRoute>
            } />
            <Route path="/creditors" element={
              <ProtectedRoute>
                <CreditorsList />
              </ProtectedRoute>
            } />
            <Route path="/templates" element={
              <ProtectedRoute>
                <div><h2>Шаблоны</h2><p>Раздел в разработке</p></div>
              </ProtectedRoute>
            } />
            <Route path="/documents" element={
              <ProtectedRoute>
                <DocumentsList />
              </ProtectedRoute>
            } />
            <Route path="/accounts" element={
              <ProtectedRoute>
                <AccountsList />
              </ProtectedRoute>
            } />
            <Route path="/reminders" element={
              <ProtectedRoute>
                <RemindersList />
              </ProtectedRoute>
            } />
            <Route path="/knowledge-base" element={
              <ProtectedRoute>
                <KnowledgeBase />
              </ProtectedRoute>
            } />
            <Route path="/profile" element={
              <ProtectedRoute>
                <UserProfile />
              </ProtectedRoute>
            } />
            <Route path="/users" element={
              <ProtectedRoute>
                <UsersList />
              </ProtectedRoute>
            } />
            <Route path="/support" element={
              <ProtectedRoute>
                <SupportPage />
              </ProtectedRoute>
            } />
          </Routes>
        </Layout>
      </Router>
    </AuthProvider>
  );
}

export default App;
